export class UtilityManagementCollections {
    static ModuleName = 'utility-management';

    static Attachments = `${UtilityManagementCollections.ModuleName}/attachments`;

    static attachment(attachmentId: string) {
        return `${UtilityManagementCollections.Attachments}/${attachmentId}`;
    }

    static attachmentDownloadUrl(attachmentId: string) {
        return `${UtilityManagementCollections.Attachments}/${attachmentId}/as-download-url`;
    }


    static Notifications = `${UtilityManagementCollections.ModuleName}/notifications`;
    static StockUpdates = `${UtilityManagementCollections.Notifications}/stock-updates`;
}
